import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { uniformeModulo } from "src/app/aplicaciones-modulos/spyral/diccionarios/uniformeModule";
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { DataLoginModel } from '../../model/dataLoginModel';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { ParametroInicialService } from "../../services/parametro-inicial.service";
import { ResponseParametroInicialModel } from "../../model/responseParametroInicialModel";

@Component({
  selector: 'app-parametro-inicial',
  templateUrl: './parametro-inicial.component.html',
  styleUrls: ['./parametro-inicial.component.css']
})
export class ParametroInicialComponent implements OnInit {

  dataUsuario: DataLoginModel;
  mostrarFormulario: boolean = false;
  resposiveFull: string;
  uniformeModulo: any = {};

  formulario: FormGroup;//formulario
  formularioEnviar: FormGroup;
  formularioEditar: FormGroup;

  loading: boolean = false;
  dataEditar: any = {};

  textoBuscar: string;
  columnDefs: any[];//aggrid
  rowData: ResponseParametroInicialModel[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  listaVacia: boolean = false;

  constructor(private fb: FormBuilder, private _util: UtilsService,
              private _parametroInicial: ParametroInicialService,) { }

  ngOnInit() {
    this.dataUsuario = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.uniformeModulo = uniformeModulo;
    this.resposiveFull = this.uniformeModulo.div.resposiveFull;

    this.formulario = this.fb.group({
      periodo: ['',[Validators.required]],
      codTipoDoc: ['',[Validators.required]],
      codProveedor: ['',[Validators.required]],
      codCtaDebe: ['',[Validators.required]],
      codCtaHaber: ['',[Validators.required]],
    });

    this.formularioEditar = this.fb.group({
      periodo: ['',[Validators.required]],
      codTipoDoc: ['',[Validators.required]],
      codProveedor: ['',[Validators.required]],
      codCtaDebe: ['',[Validators.required]],
      codCtaHaber: ['',[Validators.required]],
    });

    this.cargarGrid();
    this.getAllInvetarioUser();
  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'Periodo',
        field: 'periodo',
        filter: true,
        width: 150,
      },
      {
        headerName: 'Tipo de Documento',
        field: 'codTipoDoc',
        filter: true,
        width: 200,
      },
      {
        headerName: 'Código Proveedor',
        field: 'codProveedor',
        sortable: true,
        width: 200,
        filter: true
      },
      {
        headerName: 'Cod. Cta. DEBE',
        field: 'codCtaDebe',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: 'Cod. Cta. HABER',
        field: 'codCtaHaber',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 200,
        cellRendererParams: {
          onClick: this.callEditarParametroInicial.bind(this),
          label: "Editar",
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 200,
        cellRendererParams: {
          onClick: this.deleteParametroInicial.bind(this),
          label: "Eliminar",
        }
      },
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getAllInvetarioUser() {
    this.loading = true;
    this._parametroInicial.getAllParametroInicial().subscribe((res:ResponseParametroInicialModel[])=>{
      this.loading = false;
      this.rowData = res;
      if(this.rowData.length > 0){
        this.listaVacia = false;
      } else {
        this.listaVacia = true;
      }
    },(err)=>{
      console.log(err);
      this.loading = false;
      this.listaVacia = true;
      this._util.mensajeErrorVisto(err.error.mesaage);
    });
  }

  callModal(){
    document.getElementById('abrirModal').click();
  }

  agregarParametroIncial(){
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea guardar el siguiente Parametro Inicial?',
        text: '',
        action: 'Guardar',
        funcion: this._parametroInicial.createEditParametroInicial(this.formulario.value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      console.log(res);
      this.getAllInvetarioUser();
      document.getElementById('cerrarModal').click();
      this.formulario.reset();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }
  
  callEditarParametroInicial({rowData}){
    this.dataEditar = rowData;
    this.formularioEditar.get('periodo').setValue(rowData.periodo);
    this.formularioEditar.get('codTipoDoc').setValue(rowData.codTipoDoc);
    this.formularioEditar.get('codProveedor').setValue(rowData.codProveedor);
    this.formularioEditar.get('codCtaDebe').setValue(rowData.codCtaDebe);
    this.formularioEditar.get('codCtaHaber').setValue(rowData.codCtaHaber);
    document.getElementById('abrirModalEditar').click();
  }

  editarParametroInicial() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea editar el siguiente Parametro Inicial?',
        text: '',
        action: 'Editar',
        funcion: this._parametroInicial.createEditParametroInicial(this.formularioEditar.value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      console.log(res);
      document.getElementById('cerrarModalEditar').click();
      this.formularioEditar.reset();
      this.dataEditar = {};
      this.getAllInvetarioUser();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

  deleteParametroInicial({rowData}) {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea eliminar el siguiente Parametro Inicial?',
        text: '',
        action: 'Eliminar',
        funcion: this._parametroInicial.deleteParametroInicial(decodeURI(rowData.periodo)),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      console.log(res);
      this.getAllInvetarioUser();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

}
